import { render, staticRenderFns } from "./FavoriteHeaderButton.vue?vue&type=template&id=470dd9a2&scoped=true&"
import script from "./FavoriteHeaderButton.vue?vue&type=script&lang=js&"
export * from "./FavoriteHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470dd9a2",
  null
  
)

export default component.exports